export const UPPER = 'upper'
export const LOWER = 'lower'

export const ALL_DRIVE_STATION_TYPES = [
  UPPER,
  LOWER,
] as const

export type DriveStationType = typeof ALL_DRIVE_STATION_TYPES[number]
